import DOMPurify from 'isomorphic-dompurify';

interface Props {
  content: string;
}

const RichTextContent = ({ content }: Props) => {
  return (
    <span
      className="text-body [&_a]:underline [&_a]:underline-offset-4"
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
    />
  );
};

export default RichTextContent;
